import { Injectable } from '@angular/core';
import { SettingsService } from 'src/app/services/settings.service';

export enum CompetitorsListFiltersEnum {
  NO_FILTER = "no_filter",
  NOT_PAYED = "not_payed_competitors",
  NO_DOCS = 'no_docs',
  NOT_PROCESSED = 'not_processed_competitors',
  WITH_ERRORS_IN_DOCS = 'with_errors_in_docs',
  NOT_CONFIRMED = 'not_confirmed',
  UNDER_18 = 'under_18',
  UNDER_16 = 'under_16',
  DELETED = 'deleted_reg',
}

@Injectable({
  providedIn: 'root'
})
export class CompetitorsListFilterSelectorService {

  constructor(private appSettings: SettingsService) { }

  private selectedCompetitorsListFilter: CompetitorsListFiltersEnum = CompetitorsListFiltersEnum.NO_FILTER

  setSelectedCompetitorsListFilter(filterItem: CompetitorsListFiltersEnum): void {
    this.selectedCompetitorsListFilter = filterItem;
  }

  getSelectedCompetitorsListFilter(): CompetitorsListFiltersEnum {
    return this.selectedCompetitorsListFilter;
  }

  public readonly values: CompetitorsListFiltersEnum[] = [
    CompetitorsListFiltersEnum.NO_FILTER,
    CompetitorsListFiltersEnum.NOT_PAYED,
    CompetitorsListFiltersEnum.NO_DOCS,
    CompetitorsListFiltersEnum.NOT_PROCESSED,
    CompetitorsListFiltersEnum.WITH_ERRORS_IN_DOCS,
    CompetitorsListFiltersEnum.NOT_CONFIRMED,
    CompetitorsListFiltersEnum.UNDER_18,
    CompetitorsListFiltersEnum.UNDER_16,
    CompetitorsListFiltersEnum.DELETED
  ]

}
